
import { withDefaultErrorBoundary } from '@/modules/shared/hoc/withDefaultErrorBoundary'
import { EmailSettingsPageContent } from './EmailSettingsPageContent'

export const EmailSettingsPage = withDefaultErrorBoundary(EmailSettingsPageContent)
